<template>
  <div class="max-w-full max-h-150">
    <ResourceDetailsHeader />
  </div>
  <div class="max-w-full max-h-150 overflow-auto">
    <div v-if="isActiveSection(resourceSection)">
      <resource-info :resource="resource" />
    </div>
    <div v-else-if="isActiveSection(fieldsSection)">
      <data-fields :fields="resource.service_information.attributes" />
    </div>
    <div v-else-if="isActiveSection(sampleSection)">
      <data-sample :id="resource.id" />
    </div>
    <div v-else-if="isActiveSection(pythonSection)">
      <python-example :id="resource.id" />
    </div>
    <div v-else>
      <distributions :resource="resource" />
    </div>
  </div>
</template>

<script>
import ResourceDetailsHeader from '@/components/details-components/ResourceDetailsHeader'
import { computed, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import ResourceInfo from '@/components/details-components/ResourceInfo'
import DataFields from '@/components/details-components/DataFields'
import DataSample from '@/components/details-components/DataSample'
import PythonExample from '@/components/details-components/PythonExample'
import Distributions from '@/components/details-components/Distributions'
export default {
  name: 'ResourceDetails',
  components: { Distributions, PythonExample, DataSample, DataFields, ResourceInfo, ResourceDetailsHeader },
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const store = useStore()
    function isActiveSection(section) {
      return activeSection.value === section.id
    }

    const resourceSection = { label: 'Resource Information', id: 'resourceInfo', icon: 'fas fa-circle-info' }
    const fieldsSection = { label: 'Data Fields', id: 'attributes', icon: 'fas fa-bars' }
    const sampleSection = { label: 'Data Sample', id: 'sampleData', icon: 'fas fa-table-cells' }
    const pythonSection = { label: 'Python Example', id: 'pythonExample', icon: 'fab fa-python' }
    const distributionSection = { label: 'Distributions', id: 'distributions', icon: 'fab fa-cloud-arrow-down' }

    const detailsSections = [resourceSection, fieldsSection, sampleSection, pythonSection, distributionSection]

    const activeSection = computed(() => store.state.Details.activeSection.id)

    onBeforeMount(() => {
      store.state.Details.availableSections = detailsSections
      store.state.Details.activeSection = resourceSection
    })

    return {
      activeSection,
      isActiveSection,
      detailsSections,
      resourceSection,
      fieldsSection,
      sampleSection,
      pythonSection,
      distributionSection,
    }
  },
}
</script>

<style scoped>

</style>
